/** @jsxRuntime classic */
/** @jsx jsx */
import { ReactNode } from 'react';
import { jsx } from '@emotion/core';

import { Box, GutterSizes } from 'src/components/Box';
import { H6, P } from 'src/components/Text';
import { Margins, Responsive } from 'src/design-system/style-types';

interface RequiredProps {
  title?: string | ReactNode;
  blurb: string | ReactNode;
  children: ReactNode;
}

interface DefaultProps {
  marginBottom: Margins;
  className: string;
  blurbWidth: Responsive<number | string>;
  childrenWidth: Responsive<number | string>;
  gutterSize: Responsive<GutterSizes>;
  disabled?: boolean;
}

const defaultProps: DefaultProps = {
  marginBottom: '0',
  className: '',
  blurbWidth: { xs: 12, md: 6 },
  childrenWidth: { xs: 12, md: 6 },
  gutterSize: 'lg',
};

export const TitleBlurbBodyLayout = (props: RequiredProps & DefaultProps) => {
  const { children, title, blurb, marginBottom, className, blurbWidth, childrenWidth, gutterSize, disabled } = props;

  const textColor = disabled ? 'grey' : undefined;

  return (
    <Box mb={marginBottom} className={className} role="container">
      {title && (
        <Box mb="sm">
          <H6 color={textColor} size="md" weight="normal">
            {title}
          </H6>
        </Box>
      )}
      <Box g={gutterSize}>
        <Box w={blurbWidth} mb={{ xs: 'xl', md: '0' }}>
          <P color={textColor} size="sm">
            {blurb}
          </P>
        </Box>
        <Box w={childrenWidth}>{children}</Box>
      </Box>
    </Box>
  );
};

TitleBlurbBodyLayout.defaultProps = defaultProps;
